import type { ModuleDashboardProvider } from '@/types/dashboard.types';

export const ideaDevelopmentDashboardProvider: ModuleDashboardProvider = {
  moduleId: 'idea-development',
  moduleName: 'Ideen Entwicklung',
  moduleIcon: 'bulb-outline',
  
  widgets: []
};
